import React, { useState } from "react";
import "react-table/react-table.css";
import { searchSpecialCustomer } from "../../api/IrsClient";
import { formatDate } from "../../utils/datetime";
import Modal from "../common/Modal";
import ModalError from "../common/ModalError";
import SpecialCustomerSearchForm from "./SpecialCustomerSearchForm";
import SpecialCustomerTable from "./SpecialCustomerTable";


function SpecialCustomerConfiguration({ userRoles }) {
  const [isLoading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(null);
  const [infoModal, setInfoModal] = useState(null);

  const [specialCustomerPageable, setSpecialCustomerPageable] = useState({});
  const [specialCustomerSearchRequest, setSpecialCustomerSearchRequest] = useState({});

  function handleOnClickSearch(formValue) {
    const request = {
      mobile_number: formValue.mobile_number || null,
      country: formValue.country || null,
      exchange_rate_label: formValue.exchange_rate_label || null,
      last_updated_from: formValue.updated_date.from ? formatDate(formValue.updated_date.from) : null,
      last_updated_to: formValue.updated_date.to ? formatDate(formValue.updated_date.to) : null,
      last_updated_by: formValue.updated_by || null
    }
    setSpecialCustomerSearchRequest(request);
    callApiSearchSpecialCustomer(request);
  }

  function refreshSpecialCustomers() {
    callApiSearchSpecialCustomer(specialCustomerSearchRequest);
  }

  function handleOnPageRequestChange(page, pageSize) {
    callApiSearchSpecialCustomer({
      page,
      page_size: pageSize,
      ...specialCustomerSearchRequest
    })
  }

  async function callApiSearchSpecialCustomer(request) {
    try {
      setLoading(true);
      setSpecialCustomerPageable({});
      const { data: { status, data } } = await searchSpecialCustomer(request);
      if (status.code === "0") {
        setSpecialCustomerPageable(data);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* modals */}
      <Modal
        message={infoModal?.title}
        textOk={infoModal?.textOk || "Ok"}
        textCancel={infoModal?.textCancel}
        isOpen={!!infoModal}
        description={infoModal?.description}
        onOk={infoModal?.onOk}
        onCancel={infoModal?.onCancel}
      />
      <ModalError
        message={errorModal?.title ?? "System Error"}
        isOpen={!!errorModal}
        description={errorModal?.description ?? ""}
        onRequestClose={() => setErrorModal(null)}
      />

      <div className="container">
        <SpecialCustomerSearchForm
          isLoading={isLoading}
          onClickSearch={handleOnClickSearch}
        />
        <SpecialCustomerTable
          specialCustomerPageable={specialCustomerPageable}
          onRefreshSpecialCustomerUpdate={refreshSpecialCustomers}
          onPageRequestChange={handleOnPageRequestChange}
          isLoading={isLoading}
          setInfoModal={setInfoModal}
          setErrorModal={setErrorModal}
        />
      </div>
    </>
  );
}

export default SpecialCustomerConfiguration;
